import React from 'react'
import { Divider, Input, Tree, Button, message } from 'antd'
import Title from '@/compenents/title'
import './setRole.less'
import { axiosPost } from '@/server/index'
import common from '@/public/common'
import { getCookieNew } from '@/public/utils'
import {CloseOutlined} from '@ant-design/icons';
const { TreeNode } = Tree;
const { Search } = Input;


class SetRole extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            userData: Object,
            roleList: [],
            dataList: [],
            checkedKeys: [],
            autoExpandParent: true,
            expandedKeys: [],
            searchValue: '',
            selectRoles: [],//已选角色
        }
    }


    componentDidMount() {
        //获取当前登录用户
        let userInfo =getCookieNew("supplierinfo") ? JSON.parse(getCookieNew("supplierinfo")) : {}
        if (this.props.location.state.userData) {
            this.setState({
                userData: this.props.location.state.userData
            })
        }
        //获取角色list
        axiosPost(common.eurekaUrlDic + '/permission/rolegroup/query', {
            supplierCompanyCode:getCookieNew("supplier_company_code")||"",
            roleType:"supplier"
        }).then(res => {
            if (res.status === 200) {
                this.initBoj(res.data)
                this.setState({
                    roleList: res.data,
                    adminInfo: userInfo
                }, () => {
                    this.generateList(this.state.roleList);
                    this.getSelect(this.state.userData.rolelist)
                })
            }
        })
    }

    //回显角色数据
    getSelect = (data) => {
        console.log(data)
        const { roleList } = this.state
        let arr = []
        let arr1 = []
        if (data && data.length && roleList && roleList.length) {
            for (let k = 0; k < data.length; k++) {
                for (let i = 0; i < roleList.length; i++) {
                    for (let j = 0; j < roleList[i].roles.length; j++) {
                        if (roleList[i].roles[j].roleid == data[k].roleid) {
                            arr.push(data[k].rolename + ',' + data[k].roleid)
                            arr1.push(roleList[i].roles[j])
                        }

                    }

                }
            }
            this.setState({
                checkedKeys: arr,
                selectRoles: arr1
            })
        }
    }

    //依据tree结构，改造roleList
    initBoj = (obj) => {
        for (let i = 0; i < obj.length; i++) {
            for (let k in obj[i]) {
                if (k == "roles") {
                    this.initBoj(obj[i][k])
                } else {
                    if (k == "id") {
                        obj[i].value = obj[i][k]
                        delete obj[i][k]
                    } else if (k == "rolename") {
                        obj[i].key = obj[i].rolename + ',' + obj[i].roleid
                        obj[i].title = obj[i].rolename
                        delete obj[i][k]
                    }
                }
            }
        }
    }

    //tree自带方法--搜索展开
    generateList = data => {
        let { dataList } = this.state
        for (let i = 0; i < data.length; i++) {
            const node = data[i];
            const { key } = node;
            dataList.push({ key, title: key });
            if (node.roles) {
                this.generateList(node.roles);
            }
        }
        this.setState({
            dataList
        })
    };

    //tree自带方法--搜索展开
    getParentKey = (key, tree) => {
        let parentKey;
        for (let i = 0; i < tree.length; i++) {
            const node = tree[i];
            if (node.roles) {
                if (node.roles.some(item => item.key === key)) {
                    parentKey = node.key;
                } else if (this.getParentKey(key, node.roles)) {
                    parentKey = this.getParentKey(key, node.roles);
                }
            }
        }
        return parentKey;
    };

    //点击展开方法
    onExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    };

    //tree搜索
    onChange = e => {
        let { roleList } = this.state
        const { value } = e.target;
        const expandedKeys = this.state.dataList
            .map(item => {
                if (item.title.indexOf(value) > -1) {
                    return this.getParentKey(item.key, roleList);
                }
                return null;
            })
            .filter((item, i, self) => item && self.indexOf(item) === i);
        this.setState({
            expandedKeys,
            searchValue: value,
            autoExpandParent: true,
        });
    };

    //tree点击选中
    onCheck = checkedKeys => {
        const { roleList } = this.state
        let req
        let arr1 = []
        for (let i = 0; i < checkedKeys.length; i++) {
            let arr = checkedKeys[i].split(',')
            let req = arr[0]
            let a = undefined
            if (arr[1] != 'undefined') {
                for (let j = 0; j < roleList.length; j++) {
                    if (roleList[j].roles) {
                        for (let k = 0; k < roleList[j].roles.length; k++) {
                            if (roleList[j].roles[k].title == req) {
                                arr1.push(roleList[j].roles[k])
                            }
                        }
                    }
                }
            }
        }
        this.setState({
            checkedKeys,
            selectRoles: arr1
        });
    };

    //右侧删除
    del = (item) => {
        const { selectRoles, checkedKeys } = this.state
        //已选角色删除
        if (selectRoles && selectRoles.length) {
            for (let i = 0; i < selectRoles.length; i++) {
                if (selectRoles[i].roleid == item.roleid) {
                    selectRoles.splice(i, 1)
                }
            }
        }
        //tree取消选中
        for (var j in checkedKeys) {
            let str = checkedKeys[j]
            let arr = str.split(',')
            if (arr[1] == item.roleid) {
                checkedKeys[j] = ''
            }
            if (arr[0] == item.rolegroup) {
                checkedKeys[j] = ''
            }

        }
        for (let k = 0; k < checkedKeys.length; k++) {
            if (checkedKeys[k] == '') {
                checkedKeys.slice(k, 1)
            }
        }
        this.setState({
            selectRoles,
            checkedKeys
        })
    }

    //tree选中成为受控
    renderTreeNodes = data =>
        data.map(item => {
            let title = ''
            const { searchValue } = this.state
            if (item.title) {
                const index = item.title.indexOf(searchValue);
                const beforeStr = item.title.substr(0, index);
                const afterStr = item.title.substr(index + searchValue.length);
                title =
                    index > -1 ? (
                        <span>
                            {beforeStr}
                            <span style={{ color: '#f50' }}>{searchValue}</span>
                            {afterStr}
                        </span>
                    ) : (
                            <span>{item.title}</span>
                        );
            }
            if (item.roles) {
                return (
                    <TreeNode key={item.key} title={title}>
                        {this.renderTreeNodes(item.roles)}
                    </TreeNode>
                );
            }
            return <TreeNode key={item.key} title={title} disabled={item.isUserCanDelete == false}></TreeNode>;
        });

    //提交
    submit = () => {
        const { userData, selectRoles, adminInfo } = this.state
        let rolelist = []
        for (let i = 0; i < selectRoles.length; i++) {
            rolelist.push(selectRoles[i].roleid)
        }
        if (!rolelist.length) {
            message.error('请至少为当前用户设置一个角色')
            return
        }
        let reqData = {
            modifyname: adminInfo.real_name,
            rolelist,
            userid: +userData.userid,
            roleType:"supplier",
              poSubjectCode: getCookieNew("po_subject_code") || "",
      businessId: getCookieNew("businessId")||"",
      businessName:getCookieNew("business_name")||"",
      supplierCode: getCookieNew("supplier_code")||"",
      supplierCompanyCode: getCookieNew("supplier_company_code")||"",
      supplierCompanyName: getCookieNew("supplier_company_name") || "",
        }
        axiosPost(common.eurekaUrlDic + '/permission/user/setrole', reqData).then(res => {
            if (res.status == 200) {
                message.success("设置成功")
            }

        })
    }

    render() {
        const { searchValue, expandedKeys, autoExpandParent, userData, selectRoles, checkedKeys } = this.state
        const loop = data =>
            data.map(item => {
                let title = ''
                if (item.title) {
                    const index = item.title.indexOf(searchValue);
                    const beforeStr = item.title.substr(0, index);
                    const afterStr = item.title.substr(index + searchValue.length);
                    title =
                        index > -1 ? (
                            <span>
                                {beforeStr}
                                <span style={{ color: '#f50' }}>{searchValue}</span>
                                {afterStr}
                            </span>
                        ) : (
                                <span>{item.title}</span>
                            );
                }
                if (item.roles) {
                    return (
                        <TreeNode key={item.key} title={title}>
                            {loop(item.roles)}
                        </TreeNode>
                    );
                }
                return <TreeNode key={item.key} title={title}></TreeNode>;
            });
        return (
            <div className='setRole'>
                <div className='setRole_body'>
                    <div className='body'>
                        <p>你正在为用户<span className='blue'>{userData.reallyname + '(' + userData.username + ')'}</span>设置角色：</p>
                        <div className='flex-part'>
                            <div className='roleTree'>
                                <div className='flr'>
                                    <Search style={{ marginBottom: 8 }} placeholder="搜索角色" onChange={this.onChange} />
                                    <Tree
                                        checkable
                                        onExpand={this.onExpand}
                                        onCheck={this.onCheck}
                                        checkedKeys={checkedKeys}
                                        expandedKeys={expandedKeys}
                                        autoExpandParent={autoExpandParent}
                                    >
                                        {this.renderTreeNodes(this.state.roleList)}
                                    </Tree>
                                </div>

                            </div>
                            <div className='selectRole'>
                                <div className='fll'>
                                    <div className='title'>已选角色：</div>
                                    {
                                        selectRoles && selectRoles.length > 0 ?
                                            selectRoles.map((item, index) => {
                                                return (
                                                    <div className='detail' key={item.roleid}>
                                                        <span className='role'>{item.rolegroup + '>' + item.title}</span>
                                                        <span style={{ fontSize: '17px', cursor: "pointer" }}>{item.isUserCanDelete==true&&<CloseOutlined onClick={this.del.bind(this, item)} /> }</span>
                                                    </div>
                                                )
                                            })
                                            : null
                                    }

                                </div>
                            </div>
                        </div>
                        <div>
                            <Button type="primary" shape="round" onClick={this.submit.bind(this)} style={{ marginLeft: '48%', marginTop: '80px' }}>提交</Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default SetRole



// WEBPACK FOOTER //
// ./src/pages/authorityManagement/setRole.js